<div class="seperator"></div>
<div class="title" mat-dialog-title>
    Enable DoubleVerify
    <img class="logo" src="https://rubii-images.s3-ap-southeast-2.amazonaws.com/dsp/dv.png" alt="DoubleVerify" />
</div>
<div class="gmail-body">
    <div style="text-align: left;">
        <div>Please schedule a daily report and send to below email: </div>
        <div class="report-email-container">
            <div style="font-weight: 600;">Recipient email address</div>
            <div class="dv-email">
                <div>{{ dvEmail }}</div>  
                <button mat-icon-button (click)="copyMessageToClipboard(dvEmail)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
        <div class="ias-template-link"><a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/doubleverify.xlsx"
                target="_blank" data-cy="doubleverify-template-link"> Download a sample report </a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>
